import React from 'react'

import {LocationsTable} from "../../components/LocationsTable";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import {BaseModal} from "../../components/BaseModal";


export const LocationModal = (props) => {
    const {
        initialLocation,
        selectLocation,
        open,
        onClose,
        setIsOpen,
        isSaving,
    } = props
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })

    const style = {
        position: 'absolute',
        top: '50%',
        minWidth: isTabletOrMobile ? '' : '660px',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        background: 'white',
        boxShadow: 24,
        // padding: '30px',
        zIndex: '1400',
        outline: 'none',
        borderRadius: '8px'
    };


    return (
        <BaseModal
            isOpen={open}
            onClose={onClose}
            setIsOpen={setIsOpen}
            style={style}
        >
            <LocationsTable
                initialLocation={initialLocation}
                selectLocation={selectLocation}
                isDealLocation={true}
                isSaving={isSaving}
                isProfilePage={false}
            />
        </BaseModal>
    )
}